// extracted by mini-css-extract-plugin
export default {"backdropDiv":"dropdown_backdropDiv__7mfZ2","positionDiv":"dropdown_positionDiv__UEj2n"};